import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';

export interface PermissionsContext {
  accountChangeRequestEnabled: boolean;
  riskLimitRequestEnabled: boolean;
  accountOpeningFormEnabled: boolean;
  generalRequestsEnabled: boolean;
  cashMovementRequestsEnabled: boolean;
  achPullRequestsEnabled: boolean;
  bulkCashMovementRequestsEnabled: boolean;
}

const context = createContext<PermissionsContext>({
  accountChangeRequestEnabled: false,
  riskLimitRequestEnabled: false,
  accountOpeningFormEnabled: false,
  generalRequestsEnabled: false,
  cashMovementRequestsEnabled: false,
  achPullRequestsEnabled: false,
  bulkCashMovementRequestsEnabled: false
});

export const usePermissions = () => useContext(context);

interface PermissionsProviderProps {
  children: ReactNode;
  permissions: PermissionsContext;
}

export const PermissionsProvider = ({
  children,
  permissions = {
    accountChangeRequestEnabled: false,
    riskLimitRequestEnabled: false,
    accountOpeningFormEnabled: false,
    generalRequestsEnabled: false,
    cashMovementRequestsEnabled: false,
    achPullRequestsEnabled: false,
    bulkCashMovementRequestsEnabled: false
  }
}: PermissionsProviderProps) => {
  const [userPermissions, setUserPermissions] = useState(permissions);

  useEffect(() => {
    if (permissions) setUserPermissions(permissions);
  }, [permissions]);

  return (
    <context.Provider
      value={{
        ...userPermissions
      }}
    >
      {children}
    </context.Provider>
  );
};
